export default "/images/Fabrik.gif?538fa3f633f80ccb02037419bdd61706";